module.exports = __webpack_public_path__ + "31b6f1bcf40a2926a2ca12c12335a28c.svg";